import React from 'react';
import {IRenderMenuItemOptions} from "../../../menu-items-common/renderer/menu-item.renderer.interface";
import {
    BottomNavigationBarMenuItemComponent
} from "../../../../components/bottom-navigation-bar/bottom-navigation-bar-menu-item.component";
import {MenuItemRendererBase} from "../../../menu-items-common/renderer/menu-item-renderer-base";
import {
    IMenuItemConfigReader
} from "../../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {
    IMenuItemActionFactoryService
} from "../../../menu-item-action-factory/menu-item-action-factory.service.interface";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {
    BottomNavigationBarBadgeBox
} from "../../../../components/bottom-navigation-bar/boxes/badge/bottom-navigation-bar.badge.box";

export default class ExplorerBottomNavigationBarMenuItemRenderer extends MenuItemRendererBase {

    constructor(configReader: IMenuItemConfigReader,
                services: IServiceFactoryExtended,
                menuItemActionFactory: IMenuItemActionFactoryService) {
        super('videoSlideExploreMenuItem', configReader, services, menuItemActionFactory);
    }

    protected _createReactElement(options?: IRenderMenuItemOptions): React.ReactElement {
        return (<BottomNavigationBarMenuItemComponent key={this.key} menuItem={this} badge={this.getBadgeComponent()}/>);
    }

    protected getBadgeComponent() {
            return () => {
                const services = useServices();
                if (services.videoSlides.shouldShowExplorerMenuBadge) {
                    return <BottomNavigationBarBadgeBox>
                        {services.translation.translate('EXPLORER_BADGE_NEW')}
                    </BottomNavigationBarBadgeBox>
                } else {
                    return null;
                }
            }
    }
}